module.exports = __webpack_public_path__ + "img/1-quad.5b43819f.png";